module.exports = __webpack_public_path__ + "img/7.0d7dc881.jpg";